import { createPortal } from 'react-dom';
import { rootActions, useAppDispatch, useAppSelector } from '../../DAL/store';
import TopPopup from './top-popup';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

/**
 * https://wavesaudio.atlassian.net/browse/MRKT-22757
 */
const TopButtonPortal = () => {

    const dispatch = useAppDispatch();

    const $placeholder = document.getElementById('eligible-popup-button') as HTMLElement;

    const isTopPopupOpened = useAppSelector(store => store.isTopPopupOpened);

    const onClick = () => {
        dispatch(
            rootActions.main({
                isTopPopupOpened: true,
            })
        );

        sendGAEvent('Free Plugins', 'Am I Eligible');
    };

    return (
        <div>
            {
                $placeholder &&
                createPortal(
                    <>
                        <p className="waves-p pb-8">
                            <button
                                onClick={ onClick }
                                className="underline text-blue-200"
                                type="button">
                                Am I eligible for free plugins?
                            </button>
                        </p>

                        {
                            isTopPopupOpened &&
                            <TopPopup />
                        }
                    </>,
                    $placeholder,
                )
            }
        </div>
    )
};

export default TopButtonPortal;